<template>
    <div
        class="o-p-floor-list"
        :style="{...componentStyles, ...aPListHeaderParams.style, ...aPListItemParams.style}"
    >
        <template
            v-for="(floor, index) in terminalBuildingFloors"
        >
            <APListHeader
                :key="floor.id + index"
                :title="t(floor, 'name')"
                :params="aPListHeaderParams.params"
                :class="{
                    'a-p-list-header--active': isActiveFloor(floor.id),
                    'a-p-list-header--short': isFloorShort(floor)
                }"
            >
                <template #title-icon>
                    <div 
                        v-if="isActiveFloor(floor.id)"
                        class="a-p-list-header__info-here"
                    >
                        <div 
                            class="a-p-list-header__info-here-inside"
                        >
                        </div>
                        <div 
                            class="a-p-list-header__info-here-text"
                            v-html="$t(componentParams.du_ar_har, 'Du er </br> her')"
                        />
                    </div>
                </template>
                <template>
                    <div class="a-p-list-header__service-icon-wrapper">
                        <img 
                            class="a-p-list-header__service-icon"
                            v-for="service in getFloorServices(floor.id)"
                            :key="service.id"
                            :src="service.files.icon" 
                            alt="service icon"
                        >
                    </div>
                </template>
            </APListHeader>
            <div
                :key="floor.id + index + 'i'"
                class="tenants-wrapper"
                :style="{...getListStyle(getPreparedFloorTenants(floor.id), isFloorShort(floor))}"
            >
                <div 
                    class="tenants-column"
                    v-for="(group, groupIndex) in getPreparedFloorTenants(floor.id)"
                    :key="group[0].id + groupIndex"
                >
                    <APListItem
                        v-for="(tenant, i) in group"
                        :key="tenant.id + 'i' + i"
                        :title="tenant.meta[`name_${locale}`] || tenant.meta.name"
                        :dark="checkDarckItem(i, groupIndex, getPreparedFloorTenants(floor.id))"
                        :class="{
                            'a-p-list-item--short': isFloorShort(floor),
                            'a-p-list-item--category': tenant.root_id
                        }"
                    >
                        <template>
                            <span></span>
                        </template>
                    </APListItem>
                </div>
            </div>
        </template>
        <OPQrWidget />
    </div>
</template>

<script>
import {
    mapState,
    mapGetters
} from 'vuex'

import {COLUMN_COUNT} from './constants'

import OPQrWidget from '../o-p-qr-widget/o-p-qr-widget'
import APListItem from '../../atoms/a-p-list-item/a-p-list-item'
import APListHeader from '../../atoms/a-p-list-header/a-p-list-header'

import uniqBy from 'lodash/uniqBy'
import groupBy from 'lodash/groupBy'

export default {
    name: 'OPFloorListSmart',
    components: {
        OPQrWidget,
        APListItem,
        APListHeader
    },
    props: {
        view: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            aPListItemParams: {},
            aPListHeaderParams: {}
        }
    },
    computed: {
        ...mapState({
            locale: state => state.activeLocale
        }),
        ...mapGetters([
            't',
            'getFloors',
            'getTerminalId',
            'getFloorTenants',
            'getCategoryById',
            'getMapConfigProp',
            'getBuildingFloors',
            'getServicesObjects',
            'getDenormalisedObjectById'
        ]),
        commonConfigStyles() {
            return this.getMapConfigProp('components.OPFloorListSmart.styles') || {};
        },
        viewConfigStyles() {
            return this.getMapConfigProp(`views.${this.view}.OPFloorListSmart.styles`) || {};
        },
        componentStyles() {
            return {
                ...this.commonConfigStyles,
                ...this.viewConfigStyles
            }
        },
        commonConfigParams() {
            return this.getMapConfigProp('components.OPFloorListSmart.params') || {};
        },
        viewConfigParams() {
            return this.getMapConfigProp(`views.${this.view}.OPFloorListSmart.params`) || {};
        },
        componentParams() {
            return {
                ...this.commonConfigParams,
                ...this.viewConfigParams
            }
        },
        floors() {
            if(this.mapedFloorProps.length) {
                return this.mapedFloorProps
            }
            return this.getFloors
        },
        mapedFloorProps() {
            if(this.floorProps) {
                return this.floorProps.map(floor => ({...this.getDenormalisedObjectById(floor.id), ...floor}))
            }
            return []
        },
        floorProps() {
            if(this.componentParams.floors) return this.componentParams.floors
            return []
        },
        getTerminalBuild() {
            return this.getDenormalisedObjectById(this.getTerminalId)?.floor.building_index
        },
        terminalBuildingFloors() {
            return this.getBuildingFloors(this.getTerminalBuild)
        },
        columnCount() {
            return +this.componentParams?.columnCount || COLUMN_COUNT
        },
        listStyle() {
            return {
                columnCount: this.columnCount,
            }
        },
        groupNumber() {
            return this.componentParams.group_number || 3;
        },
        isShowAllStores() {
            // stores have parameter - meta.is_visible_in_elevator_poster
            // if show_all_stores == true show all, else show stores only with meta.is_visible_in_elevator_poster == true
            if (this.componentParams.hasOwnProperty('show_all_stores')) {
                return this.componentParams.show_all_stores
            }
            
            return true
        }
    },
    methods: {
        getComponentsParams(componentName) {
            return {
                style: {
                    ...this.getMapConfigProp(`components.${componentName}.styles`),
                    ...this.getMapConfigProp(`views.${this.view}.${componentName}.styles`)
                },
                params: {
                    ...this.getMapConfigProp(`components.${componentName}.params`),
                    ...this.getMapConfigProp(`views.${this.view}.${componentName}.params`)
                }
            }
        },
        getFloorServices(id) {
            const filterServiceCategories = [];
            const filtredSrvices = this.getServicesObjects.filter(({floor}) => floor.id === id)
            filtredSrvices.forEach(service => {
                service?.lists?.categories?.forEach(id => {
                    filterServiceCategories.push(this.getCategoryById(id))
                })
            })
            let configServices = []
            if(this.floorProps) {
                const floor = this.floorProps.find(floor => floor.id == id)
                configServices = floor?.services ? floor?.services.map(serviseId => this.getCategoryById(serviseId)) : []
            }
            
            return uniqBy([...filterServiceCategories, ...configServices], 'id')
        },
        getConfigTenants(id) {
            if(this.floorProps) {
                const floor = this.floorProps.find(floor => floor.id == id)
                return floor?.tenants ? floor?.tenants.map(tenantId => {
                    const tenant = this.getDenormalisedObjectById(tenantId)
                    if(tenant?.id) {
                        return tenant
                    } else {
                        return {
                            id: tenantId,
                            meta: {
                                name: tenantId
                            }
                        }
                    }}) : []
            }
            return []
        },
        getPreparedFloorTenants(id) {
            const storesFromStore = this.addCategoriesToObjectsList(this.getFloorTenants(id))
            const storesFromConfig = this.getConfigTenants(id)

            const list = uniqBy([...storesFromStore, ...storesFromConfig], 'id')
            // list = list
            // TO DO add isShowAllStores logic

            return this.groupedList(list) 
        },
        isActiveFloor(floorId) {
            const terminal = this.getDenormalisedObjectById(this.getTerminalId)

            return terminal.floor.id === floorId
        },
        groupedList(list) {
            const grouperTenants = [];

            for(let i = 0; i < Math.ceil(list.length/this.groupNumber); i++) {
                for(let i2 = 0; i2 < this.groupNumber; i2++) {
                    const groupItem = list[i2 + i*this.groupNumber]
                    if(groupItem) {
                        if(!grouperTenants[i]) {
                            grouperTenants.push([])
                        }
                        grouperTenants[i].push(groupItem)
                    }
                }
            }

            return grouperTenants
        },
        checkDarckItem(itemImdex, groupIndex, list) {
            return itemImdex % 2 !== 0
            
            // const columnsNumber = list.length
            // if(columnsNumber <= this.columnCount) {
            //     return itemImdex % 2 !== 0
            // }

            // if(columnsNumber < 3 || groupIndex < 1) {
            //     if(groupIndex % 2 !== 0 || groupIndex == 0) {
            //         return itemImdex % 2 !== 0
            //     } else {
            //         return itemImdex % 2 == 0
            //     }
            // } else {
            //     if(groupIndex % 2 !== 0 || groupIndex == 0) {
            //         return itemImdex % 2 == 0
            //     } else {
            //         return itemImdex % 2 !== 0
            //     }
            // }
            
            // if(list.length % 2 !== 0) {
            //     const rowsNumbers = Math.ceil(list.length/this.columnCount);
            //     const groupRow = groupIndex < rowsNumbers ? 1 :
            //         groupIndex >= rowsNumbers*2 ? 3 : 2

            //     if(groupRow !== 2){
            //         return (itemImdex + groupIndex*this.groupNumber) % 2 !== 0
            //     } else {
            //         return (itemImdex + groupIndex*this.groupNumber) % 2 == 0
            //     }
            // } else {
            //     return (itemImdex + groupIndex*this.groupNumber) % 2 !== 0
            // }
        },
        isFloorShort(floor) {
            const configFloor = this.floorProps.find(f => f.id === floor.id)

            return configFloor ? configFloor.short : false
        },
        addCategoriesToObjectsList(list) {
            const newList = list.map(object => {
                const objCategories = object?.lists?.categories
                if(objCategories) {
                    object.lists.categoriesRoot = objCategories.map(id => {
                        let rootCategory = this.getCategoryById(id)
                        for (let category = rootCategory; category.parent_id !== category.root_id; ) {
                            category = this.getCategoryById(category.parent_id)
                            rootCategory = category;
                        }

                        return rootCategory
                    })

                    object.lists.categoriesRoot = object.lists.categoriesRoot[0]
                }

                return object
            })

            const prepareList = []

            const objectsWithCategories = Object.entries(groupBy(newList, 'lists.categoriesRoot.id'))
            
            objectsWithCategories.forEach(([categoryId, objects]) => {
                if(objectsWithCategories.length > 1) prepareList.push(this.getCategoryById(+categoryId));
                prepareList.push(...objects);
            })
            // console.log('TEST : addCategoriesToObjectsList', newList, prepareList)

            return prepareList
        },
        getListStyle(list, isShort) {
            if(list.length < 2 || isShort) {
                return {}
            } else {
                return this.listStyle
            }
        }
    },
    mounted() {
        this.aPListItemParams = this.getComponentsParams('APListItem')
        this.aPListHeaderParams = this.getComponentsParams('APListHeader')
    }
}
</script>

<style lang="scss">
@import "o-p-floor-list-smart";
</style>